import {
  asset0,
  asset1,
  asset2,
  asset3,
  asset4,
  asset5,
  asset6,
  asset7,
  asset8,
  asset9,
  asset10,
  asset11,
  asset12,
  asset13,
  asset14,
  asset15,
  placeholder,
  asset11Flip,
} from './assets'
import {
  web1 as hweb1,
  web2 as hweb2,
  web3 as hweb3,
  web4 as hweb4,
  web5 as hweb5,
  web6 as hweb6,
} from './webs/h'
import {
  web1 as iweb1,
  web2 as iweb2,
  web3 as iweb3,
  web4 as iweb4,
  web5 as iweb5,
  web6 as iweb6,
} from './webs/i'
import {
  web1 as mbweb1,
  web2 as mbweb2,
  web3 as mbweb3,
  web4 as mbweb4,
} from './webs/mod-bar'
import {
  web1 as pweb1,
  web2 as pweb2,
  web3 as pweb3,
  web4 as pweb4,
  web5 as pweb5,
} from './webs/p'
import {
  web1 as spweb1,
  web2 as spweb2,
  web3 as spweb3,
  web4 as spweb4,
  web5 as spweb5,
} from './webs/single-post'
import { web1, web2, web3, web4, web5 } from './webs/snake-eyes'
import {
  web1 as tweb1,
  web2 as tweb2,
  web3 as tweb3,
  web4 as tweb4,
} from './webs/trap'
import {
  web1 as xweb1,
  web2 as xweb2,
  web3 as xweb3,
  web4 as xweb4,
  web5 as xweb5,
  web6 as xweb6,
  web7 as xweb7,
  web8 as xweb8,
} from './webs/x'
import {
  web1 as msweb1,
  web2 as msweb2,
  web3 as msweb3,
  web4 as msweb4,
  web5 as msweb5,
  web6 as msweb6,
  web7 as msweb7,
  web8 as msweb8,
  web9 as msweb9,
} from './webs/mod-single-post'

const assets: any = [
  { src: asset0, x: 505.299, y: 119.0025, itemId: 103 },
  { src: asset1, x: 0, y: 0, itemId: 101 },
  { src: asset2, x: 708.0576, y: 2.8614 },
  { src: asset3, x: -2.9076, y: 341.4501, itemId: 102, majorLayer: true },
  { src: asset4, x: 550.7589, y: 95.5794, itemId: 106 },
  { src: asset5, x: 312.5796, y: 176.7744, itemId: 103 },
  { src: asset6, x: 150.3152, y: 690.6265 },
  { src: asset7, x: 173.8506, y: 149.8005, itemId: 104 },
  { src: asset8, x: 224.0694, y: 93.2886, itemId: 109 },
  { src: asset9, x: -12.5724, y: 118.7613, itemId: 108 },
  {
    src: asset10,
    x: 325.6242,
    y: 193.5471,
    itemId: 114,
    blendMode: 'no-blend',
    majorLayer: true,
  },
  {
    src: asset11,
    x: 64.8306,
    y: 443.3334,
    itemId: 116,
    blendMode: 'no-blend',
    hasFlippedAsset: true,
    flippedAssetIndex: 0,
  },
  { src: asset12, x: 174.9288, y: 552.8019, itemId: 110, majorLayer: true },
  { src: asset13, x: 169.1625, y: 547.0413, itemId: 112, majorLayer: true },
  { src: asset14, x: 187.8975, y: 567.1572, itemId: 111, majorLayer: true },
  { src: asset15, x: 119.877, y: 769.1481, itemId: 107 },
  { src: placeholder, x: 0, y: 0, itemId: 115, majorLayer: true },
  { src: placeholder, x: 0, y: 0, itemId: 105, majorLayer: true },
  { x: 900, y: 895, itemId: 118, fontSize: 36, majorLayer: true },
]

const flippedAssets = [
  {
    src: asset11Flip,
    x: 1069.4849,
    y: 415.9326,
    itemId: 116,
    blendMode: 'no-blend',
    assetIndex: 11,
  },
]

const webs = {
  h: [
    { src: hweb1, x: 512.6181, y: 134.8299, itemId: 105 },
    {
      src: hweb2,
      x: 574.7781,
      y: 136.7541,
      itemId: 114,
      blendMode: 'no-blend',
    },
    { src: hweb3, x: 587.0382, y: 202.6452, itemId: 105 },
    {
      src: hweb4,
      x: 592.3065,
      y: 248.1012,
      itemId: 114,
      blendMode: 'no-blend',
    },
    {
      src: hweb5,
      x: 1172.6496,
      y: 238.9131,
      itemId: 115,
      blendMode: 'no-blend',
    },
    { src: hweb6, x: 537.7722, y: 116.0598, itemId: 107 },
  ],
  i: [
    { src: iweb1, x: 621.4182, y: 143.4264, itemId: 105 },
    {
      src: iweb2,
      x: 682.9461,
      y: 149.9703,
      itemId: 114,
      blendMode: 'no-blend',
    },
    { src: iweb3, x: 700.5375, y: 289.4526, itemId: 105 },
    {
      src: iweb4,
      x: 704.0334,
      y: 293.3697,
      itemId: 114,
      blendMode: 'no-blend',
    },
    // {
    //   src: iweb5,
    //   x: 1145.5581,
    //   y: 319.695,
    //   itemId: 115,
    //   blendMode: 'no-blend',
    // },
    { src: iweb6, x: 530.5395, y: 123.1782, itemId: 107 },
  ],
  p: [
    { src: pweb1, x: 508.7316, y: 135.4452, itemId: 105 },
    { src: pweb2, x: 580.8045, y: 192, itemId: 105, darken: 10 },
    {
      src: pweb3,
      x: 548.3043,
      y: 166.1031,
      itemId: 114,
      blendMode: 'no-blend',
    },
    {
      src: pweb4,
      x: 803.1771,
      y: 395.5734,
      itemId: 116,
      blendMode: 'no-blend',
    },
    { src: pweb5, x: 449.2725, y: 142.4388, itemId: 107 },
  ],
  'mod-bar': [
    { src: mbweb1, x: 517.4466, y: 124.836, itemId: 105 },
    {
      src: mbweb2,
      x: 526.1973,
      y: 144.8502,
      itemId: 114,
      blendMode: 'no-blend',
    },
    // {
    //   src: mbweb3,
    //   x: 1186.7673,
    //   y: 163.5627,
    //   itemId: 115,
    //   blendMode: 'no-blend',
    // },
    { src: mbweb4, x: 535.3074, y: 179.4489, itemId: 107 },
  ],
  'single-post': [
    { src: spweb1, x: 760.0107, y: 131.8191, itemId: 105 },
    {
      src: spweb2,
      x: 816.6492,
      y: 133.7433,
      itemId: 114,
      blendMode: 'no-blend',
    },
    { src: spweb3, x: 514.8045, y: 279.9441, itemId: 105 },
    {
      src: spweb4,
      x: 519.7845,
      y: 284.8668,
      itemId: 114,
      blendMode: 'no-blend',
    },
    { src: spweb5, x: 526.4169, y: 114.4974, itemId: 107 },
  ],
  'snake-eyes': [
    { src: web1, x: 622.8987, y: 139.6293, itemId: 105 },
    { src: web2, x: 684.8214, y: 146.2149, itemId: 114, blendMode: 'no-blend' },
    {
      src: web3,
      x: 1147.4376,
      y: 240.9522,
      itemId: 115,
      blendMode: 'no-blend',
    },
    { src: web4, x: 801.7659, y: 377.0178, itemId: 116, blendMode: 'no-blend' },
    { src: web5, x: 558.1602, y: 119.2509, itemId: 107 },
  ],
  trap: [
    { src: tweb1, x: 519.2589, y: 274.5159, itemId: 105 },
    {
      src: tweb2,
      x: 539.1321,
      y: 288.7689,
      itemId: 114,
      blendMode: 'no-blend',
    },
    { src: tweb3, x: 544.6818, y: 142.0269, itemId: 107 },
    // {
    //   src: tweb4,
    //   x: 1154.1147,
    //   y: 359.7006,
    //   itemId: 115,
    //   blendMode: 'no-blend',
    // },
  ],
  x: [
    { src: xweb6, x: 606.1413, y: 95.2554, itemId: 107 },
    { src: xweb1, x: 514.0941, y: 105.3756, itemId: 105 },
    {
      src: xweb2,
      x: 520.7523,
      y: 111.9729,
      itemId: 114,
      blendMode: 'no-blend',
    },
    { src: xweb3, x: 626.0436, y: 196.6176, itemId: 105 },
    {
      src: xweb4,
      x: 627.8754,
      y: 205.0587,
      itemId: 114,
      blendMode: 'no-blend',
    },
    {
      src: xweb5,
      x: 1188.3273,
      y: 274.4331,
      itemId: 115,
      blendMode: 'no-blend',
    },
    { src: xweb7, x: 533.5389, y: 122.3457, itemId: 107 },
    {
      src: xweb8,
      x: 900.0057,
      y: 330.9912,
      itemId: 116,
      blendMode: 'no-blend',
    },
  ],
  'mod-single-post': [
    { src: msweb7, x: 790.1397, y: 100.0014, itemId: 107 },
    { src: msweb1, x: 782.091, y: 117.0513, itemId: 105 },
    {
      src: msweb2,
      x: 834.2085,
      y: 148.4001,
      itemId: 114,
      blendMode: 'no-blend',
    },
    { src: msweb3, x: 550, y: 245, itemId: 109 },
    { src: msweb4, x: 556.8597, y: 261.5874, itemId: 105 },
    {
      src: msweb5,
      x: 568.083,
      y: 271.8315,
      itemId: 114,
      blendMode: 'no-blend',
    },
    {
      src: msweb6,
      x: 854.0922,
      y: 357.168,
      itemId: 115,
      blendMode: 'no-blend',
    },
    { src: msweb8, x: 559.95, y: 158.2971, itemId: 107 },
    { src: msweb9, x: 641.892, y: 322.4133, itemId: 116 },
  ],
}

const data = {
  assets,
  flippedAssets,
  ...webs,
}

export default data
